import React, { useEffect, useState } from 'react';
import { IPFieldProps } from '../../types/field-props';
import CComboBox from '../types/CComboBox';
import { XTextField } from '@ioip/core/lib';
import { City, CitySelector, useArchivox } from '@ioip/archivox/lib';

export const UXCitySelector = (props: IPFieldProps<CComboBox>): JSX.Element => {

    const [ isLoading, archivox ] = useArchivox();

    const [ state, setState ] = useState<{ options: City[]; isLoading: boolean; }>({ options: [], isLoading: true })
    const field = props.field;
    const label = field.label;
    const disabled = field.readonly || field.disabled;
    const required = field.required;
    const value = props.field.value as number || 0;

    if (isLoading)
        return <div>Loading...</div>

    useEffect(() => {
        if (field.datasource != null) {
            setState({
                isLoading: false,
                options: archivox.Cities.toArray()
            });
        } else {
            setState({ isLoading: false, options: [] });
        }
    }, []);

    if (state.isLoading)
        return <XTextField readonly label={label || ''} value='Loading combobox...' />

    return <CitySelector
        selectedKey={value}
        label={label || ''}
        disabled={disabled}
        options={state.options}
        onChanged={value => props.field.value = value?.id || 0}
        required={required || false}
        errorMessage={props.field.errorMessage || ''}
    />
}